var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowBuyStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "url(#paint0_linear_316_908)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1569 22.9063C51.9467 20.1934 49.6737 18.0498 46.9079 18.0498H22.2667C19.3626 18.0498 17 20.4124 17 23.3165V47.6842C17 50.5882 19.3626 52.9509 22.2667 52.9509H50.7334C53.6375 52.9509 56.0001 50.5882 56.0001 47.6842V27.9758C56 25.5652 54.3713 23.5291 52.1569 22.9063ZM22.2667 20.5101H46.908C48.2468 20.5101 49.3689 21.4528 49.6473 22.7092H22.2667C21.2356 22.7092 20.2735 23.0082 19.4603 23.5225V23.3165C19.4603 21.7691 20.7193 20.5101 22.2667 20.5101ZM50.7333 50.4905H22.2667C20.7193 50.4905 19.4603 49.2316 19.4603 47.6842V27.9758C19.4603 26.4284 20.7193 25.1695 22.2667 25.1695H50.7334C52.2808 25.1695 53.5397 26.4284 53.5397 27.9758V32.269H45.6954C42.5869 32.269 40.058 34.798 40.058 37.9065C40.058 41.015 42.587 43.544 45.6954 43.544H53.5397V47.6842C53.5397 49.2316 52.2807 50.4905 50.7333 50.4905ZM53.5397 41.0836H45.6954C43.9435 41.0836 42.5183 39.6584 42.5183 37.9065C42.5183 36.1546 43.9435 34.7293 45.6954 34.7293H53.5397V41.0836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1519 39.2803C46.8592 39.2803 47.4326 38.7069 47.4326 37.9995C47.4326 37.2922 46.8592 36.7188 46.1519 36.7188C45.4445 36.7188 44.8711 37.2922 44.8711 37.9995C44.8711 38.7069 45.4445 39.2803 46.1519 39.2803Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_908",
    x1: 10.9149,
    y1: -1.86667e-7,
    x2: 71.6748,
    y2: 17.6036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(17 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowBuyStep1);
export default __webpack_public_path__ + "static/media/How-Buy-Step-1.4cdb5660f4c9ef03cd6d50d2256aab95.svg";
export { ForwardRef as ReactComponent };